import React from 'react'
import { useNavigate } from 'react-router-dom'
import {    Typography, Box,} from '@mui/material'

import { CustomCounterAppBar, UseImage, GenericContainer, Buttons } from '../../components'
import { useStyles } from './CargarDocsStyles'
import continueMobileImg from '../../assets/continueMobile.jpg'
import { useTranslation } from 'react-i18next';

export default function QrCloseProcess(props) {
    const localStyles = useStyles()
    const { t } = useTranslation();

    return (<GenericContainer>
        <Typography variant="h6"><b>{t("cargar_full_capture")}</b></Typography>
        <Typography variant="subtitle2">{t("cargar_document_upload_completed")}</Typography>
        <div className={localStyles.imageSection}>
            <UseImage src={continueMobileImg} className={localStyles.imageIcon} />
        </div>
    </GenericContainer>)
}